import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import "./Payment.css";
import MuiAlert from '@mui/material/Alert';
import Lottie from 'lottie-react';
import Error from '../assets/error.json';


import AppPagination from './AppPagination';
import CircularProgress from '@mui/material/CircularProgress';
import Checkout from './Checkout';
import PaymentSuccessPage from './PaymentSuccessPage';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Stack } from '@mui/material';
import CategoryBar from './CategoryBar';
import TopDonators from './TopDonators';


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const Payment = () => {
    const { REACT_APP_API_URL } = process.env;
    const token = localStorage.getItem("sign_token");

    const [products, setProducts] = useState([]);
    const [totalProducts, setTotalProducts] = useState();
    const [cartItems, setCartItems] = useState([]);
    const [cartOpen, setCartOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [userName, setUsername] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [paidFor, setPaidFor] = useState(false);
    const [errorPage, setErrorPage] = useState(false);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [productPerPage] = useState(9);
    const lastPostIndex = currentPage * productPerPage;
    const firstPostIndex = lastPostIndex - productPerPage;
    const currentProducts = products.slice(firstPostIndex, lastPostIndex);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const getAllProducts = async () => {
        let result = await axios.get(`${REACT_APP_API_URL}/get-products`);
        setProducts(result.data);
        setTotalProducts(result.data.length);
        setLoading(false);
    }

    const getDiscountProducts = async () => {
        let result = await axios.get(`${REACT_APP_API_URL}/get-discount-products`);
        setProducts(result.data);
        setTotalProducts(result.data.length);
        setLoading(false);
    }

    const getProductsFromCategory = async (cat) => {
        setLoading(true);
        let result = await axios.get(`${REACT_APP_API_URL}/get-products/${cat}`);
        setProducts(result.data)
        setTotalProducts(result.data.length);
        setCurrentPage(1);
        setLoading(false);

    };

    const getTotalCartPrice = useCallback(() => {
        let totalPrice = 0;
        if (cartItems.length > 0) {
            cartItems.forEach((cartItem) => {
                totalPrice += cartItem.unit_amount.value * cartItem.quantity;
            });
        }
        return totalPrice;
    }, [cartItems]);

    const incrementCart = (item) => {
        let index = cartItems.findIndex(obj => obj.sku === item.sku);
        if (index !== -1) {
            setCartItems((cI) => cI.map((cart, i) => i === index ? { ...cart, quantity: cart.quantity + 1 } : cart));
        }
        else {
            setCartItems([...cartItems, {
                "sku": item.sku,
                "name": item.item_name,
                "unit_amount": {
                    "currency_code": "USD",
                    "value": item.discount_price > 0 ? item.discount_price : item.item_price
                },
                "quantity": 1,
                "image": item.item_image,
            }])
        }
        if (!cartOpen) {
            setOpen(true);
        }
    };

    const decrementCart = (item) => {
        const itemToUpdate = cartItems.find((cartItem) => cartItem.sku === item.sku);
        if (!itemToUpdate) return;
        itemToUpdate.quantity--;
        if (itemToUpdate.quantity <= 0) {
            return setCartItems([...cartItems.filter(item => item !== itemToUpdate)]);
        } else {
            return setCartItems(() => cartItems.map((cartItem) => cartItem === itemToUpdate ? itemToUpdate : cartItem))
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const userData = await axios.post(`${REACT_APP_API_URL}/sign-user`,
                {
                    userName,
                },
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                    }
                }
            );
            if (userData.status === 200) {
                localStorage.setItem("sign_token", userData.data);
                return setLoggedIn(true);
            }
        } catch (e) {
            console.log(`error: ${e}`);
        }
    };

    const signOut = () => {
        setLoggedIn(false);
        localStorage.removeItem("sign_token");
    };

    useEffect(() => {
        getAllProducts();
    }, [])

    if (paidFor) {
        return (<PaymentSuccessPage username={userName} setPaidFor={setPaidFor} />)
    }
    if (errorPage) {
        return (
            <div className="centered">
                <div className="container narrow-container">
                    <div className="username-section">
                        <div className="username-box">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <label>Dear {userName},</label>
                                <hr />
                                <div className="form-fields">
                                    <h1 style={{ fontSize: '24px' }}>There went something wrong!</h1>
                                    <div className="lottie-container" style={{ width: '150px', textAlign: 'center', margin: 'auto', }}>
                                        <Lottie loop={true} animationData={Error} />
                                    </div>
                                    <button className='login-btn' style={{ marginTop: '25px' }} onClick={() => setErrorPage(false)}>Go back</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if (!loggedIn) {
        return (
            <>
                <div className="centered">
                    <div className="container narrow-container">
                        <div className="username-section">
                            <div className="username-box">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <label>In-game Username: </label>
                                    <hr />
                                    <div className="form-fields">
                                        <input type="text" className="field" onChange={(e) => setUsername(e.target.value)} />
                                        <input className="login-btn" type="submit" value="LOGIN" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    else {
        return (
            <>
                <div className="overlay" style={{ display: cartOpen ? 'block' : 'none' }}></div>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={open} autoHideDuration={1500} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Product successfully added to your shopping cart.
                    </Alert>
                </Snackbar>
                <Grid2 container justifyContent={'center'} py={20}>
                    <Stack spacing={1} maxWidth={1420} width='100%'>
                        <Stack direction="row" justifyContent="space-between" spacing={1}>
                            <Stack spacing={1} position='relative'>
                                <div className="open-btn" onClick={() => setCartOpen(true)}>Open shopping cart (${getTotalCartPrice()})</div>
                                {cartOpen && (
                                    <div className="shopping-cart" style={{ marginTop: 0 }}>
                                        <p className="close-btn" onClick={() => setCartOpen(false)}>Hide shopping cart</p>
                                        {
                                            cartItems.map(cartItem => {
                                                return (
                                                    <div className="cart-row" key={cartItem.name}>
                                                        <Stack direction='row' spacing={2} alignItems="center">
                                                            <Box>
                                                                <img src={cartItem.image} alt={cartItem.name} width={64} height={64} />
                                                            </Box>
                                                            <Box>
                                                                {cartItem.name} x{cartItem.quantity} - ${cartItem.quantity * cartItem.unit_amount.value}
                                                                <div className="adjust flex-wrap">
                                                                    <p onClick={() => incrementCart(cartItem)}>+</p>
                                                                    <p onClick={() => decrementCart(cartItem)}>-</p>
                                                                </div>
                                                            </Box>
                                                        </Stack>

                                                    </div>
                                                )
                                            })
                                        }
                                        <p>Total price: ${getTotalCartPrice()}</p>
                                    </div>
                                )}
                                <CategoryBar getAllProducts={getAllProducts} getDiscountProducts={getDiscountProducts} getProductsFromCategory={getProductsFromCategory} />
                            </Stack>
                            <TopDonators />
                        </Stack>
                        {loading ? (
                            <div className="shop-section" style={{ textAlign: 'center', display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                <CircularProgress sx={{ color: 'red' }} size="5rem" color="success" />
                            </div>
                        ) : (
                            <div className="shop-section">
                                <div className="grid-2">
                                    <div className="container">
                                        <div className="grid-3">
                                            {
                                                currentProducts.map(product => {
                                                    return (
                                                        <div key={product.item_name} className="product-card" onClick={() => incrementCart(product)}>
                                                            <img src={product.item_image} alt={product.item_name} />
                                                            <h3>{product.item_name}</h3>
                                                            <p style={{ fontSize: '18px', marginTop: '15px' }}>{product.discount_price > 0 ? (<><s style={{ color: '#b70909' }}>${product.item_price}</s> <span style={{ color: '#66f166', textShadow: '0px 0px 10px #66f166' }}>${product.discount_price}</span></>) : (<span style={{ textShadow: '0px 0px 10px gold' }}>${product.item_price}</span>)}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <AppPagination
                                            totalProducts={totalProducts}
                                            productPerPage={productPerPage}
                                            setCurrentPage={setCurrentPage}
                                            currentPage={currentPage}
                                        />

                                    </div>
                                    <div className="container">
                                        {/* <h2><span style={{ color: 'whitesmoke' }}><a href="https://discord.gg/uXweNEFMnD">Click Here To Donate Via PayPal or OSGP</a></span></h2> */}
                                        <br></br>
                                        <h3 className='shopuser'>You're currently shopping for the user: <span style={{ color: 'red' }}>{userName}</span></h3>
                                        <p style={{ marginTop: '15px', marginBottom: '50px' }}>Change shopping user?<span onClick={() => signOut()} style={{ color: 'red', cursor: 'pointer' }}> Click here</span></p>
                                        {cartItems.length > 0 && userName.length > 0 &&
                                            <Checkout userName={userName} cartItems={cartItems} />
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                    </Stack>
                </Grid2 >
            </>

        )

    }
}

export default Payment